import { useTranslation } from 'hooks';
import { FormLayout } from '../components/FormLayout';
import classNames from 'classnames';
import InputPassword from 'components/ui/inputPassword';
import Icon from 'components/ui/icon';
import { NewButton as Button } from '../components/NewButton';

interface Props {
  password: string;
  passwordType: string;
  passwordConfirm: string;
  passwordConfirmType: string;
  settings: any;
  validation: any;
  text?: string;
  onChange: (key: string, value: any) => void;
  onSave: () => void;
}

export const PasswordChangeForm: React.FC<Props> = ({
  text,
  password,
  passwordType,
  passwordConfirm,
  passwordConfirmType,
  settings,
  validation,
  onChange,
  onSave,
}) => {
  const getTranslate = useTranslation();

  const canChange = () => {
    return Boolean(password && passwordConfirm) && password === passwordConfirm;
  };

  return (
    <>
      <FormLayout
        title='auth.changePassword.header'
        text={text}
        subtext='auth.changePassword.info.description'
        body={
          <>
            <InputPassword
              customClass={classNames({ 'ui-input_empty': !password })}
              id='password'
              type={passwordType}
              label={getTranslate('auth.changePassword.newPassword.label')}
              placeholder={getTranslate('auth.newPasswordPlaceholder')}
              value={password}
              onChange={(event) => onChange('password', event.target.value)}
              error={validation && validation.newPassword}
              modern
              suffix={
                <Icon
                  onClick={() =>
                    onChange(
                      'passwordType',
                      passwordType === 'password' ? 'text' : 'password'
                    )
                  }
                  name={
                    passwordType === 'password' ? 'im-Eye-close' : 'im-Eye-open'
                  }
                />
              }
            />

            <InputPassword
              customClass={classNames({ 'ui-input_empty': !passwordConfirm })}
              id='passwordConfirm'
              type={passwordConfirmType}
              label={getTranslate('auth.changePassword.confirmPassword.label')}
              placeholder={getTranslate('auth.passwordConfirmPlaceholder')}
              value={passwordConfirm}
              error={validation && validation.newPassword2}
              onChange={(event) =>
                onChange('passwordConfirm', event.target.value)
              }
              modern
              suffix={
                <Icon
                  onClick={() =>
                    onChange(
                      'passwordConfirmType',
                      passwordConfirmType === 'password' ? 'text' : 'password'
                    )
                  }
                  name={
                    passwordConfirmType === 'password'
                      ? 'im-Eye-close'
                      : 'im-Eye-open'
                  }
                />
              }
            />
          </>
        }
        submitButton={
          <Button disabled={!canChange()} type='submit'>
            {getTranslate('auth.changePassword.confirm.button')}
          </Button>
        }
        onSubmit={() => {
          if (canChange()) {
            onSave();
          }
        }}
      />

      <div className='form-layout__link'>
        <a href={`mailto:${settings.supportEmail}`} className='utils-link'>
          {getTranslate('auth.contact.link')}
        </a>
      </div>
    </>
  );
};
